"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryOperation = void 0;
/**
 * Retries a given asynchronous operation with a specified number of attempts and delay between retries.
 *
 * This function will execute the provided `operation` function. If the operation fails (throws an error), it will
 * retry up to the specified number of attempts (`retries`). After each failed attempt, the `onRetry` callback is
 * invoked with a message describing the failure. The function waits for `retryDelayMs` milliseconds before retrying.
 * If the operation fails on the final attempt, the error is thrown.
 */
async function retryOperation(operation, onRetry, retries) {
    if (retries <= 1) {
        throw new Error(`Retries must be greater than 1. ${retries} given.`);
    }
    let lastError = 'An unknown error occurred';
    for (let attempt = 1; attempt <= retries; attempt++) {
        try {
            return await operation();
        }
        catch (error) {
            // Narrow the type of error to `Error` to safely access its properties
            if (error instanceof Error) {
                lastError = error.message;
            }
            if (attempt === retries) {
                break;
            }
            onRetry(`Attempt ${attempt} failed: ${lastError}.`);
        }
    }
    throw new Error(`Exceeded maximum retries. Last error: ${lastError}`);
}
exports.retryOperation = retryOperation;
//# sourceMappingURL=retry-operation.js.map